// 11-03-2026
import { Avatar, Button, Card, Label } from "@fluentui/react-components";
import {
  AddFilled,
  LayerRegular,
  DocumentCopyRegular,
  ChatMultipleRegular,
  DocumentAddRegular,
  ShieldTaskRegular,
  DocumentOnePageAddRegular,
  ArrowCircleLeftRegular,
  HomeRegular,
  SettingsRegular,
  TaskListLtrRegular,
} from "@fluentui/react-icons";
import axios from 'axios';
import * as React from "react";
import './Home.css';
import '../Global/Global.css';
import NewContract from "./NewContract";
import ReviewContract from "./ReviewContract";
import AskLegal from "./AskLegal";
import { useMyContext } from "../Global/Context";
import UpdateExisting from "./UpdateExisting";
import GetFilesCLM from "./GetFilesCLM";
import Settings from "../Settings/Settings";
import ContextService from "../../services/ContextService";
import { setCurrentUser, setRole, setUsers } from "../Store/Features/userValues";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../Store/hooks";
import AdhocTaskPane from "./AdhocTaskPane";
// import {  colGroupProperties, IPersonaSharedProps, Persona, PersonaSize } from "office-ui-fabric-react";
import { isStringValidated } from "../Global/constants";
import RequestAI from "./RequestAI";
import { initializeIcons } from "@fluentui/react";
import { handleTokenExpiration } from "../UtilityFunctions/CommonFunction";

interface HomeProps {
  siteURL: string;
  tokenvalue: string;
  currentUser: any;
}
const Home: React.FC<HomeProps> = ({ siteURL, tokenvalue, currentUser }) => {
  const CurrentUser = JSON.parse(localStorage.getItem("CurrentUser")||"{}")
  const dispatch = useDispatch();
  const [isOpenRequest, setisOpenRequest] = React.useState(false);
  const [isNewContract, setisNewContract] = React.useState(false);
  const [CreateRequestAI, setCreateRequestAI] = React.useState(false);
  const [ImageURL, setImageURL] = React.useState<any>({});
  const [isReviewContract, setisReviewContract] = React.useState(false);
  const [isUpdateExisting, setisUpdateExisting] = React.useState(false);
  const [isGetFilesCLM, setisGetFilesCLM] = React.useState(false);
  const [isAskLegal, setisAskLegal] = React.useState(false);
  const [isHomeOnly, setisHomeOnly] = React.useState(true);
  const [isSettings, setisSettings] = React.useState(false);
  const [AdhocTask, setAdhocTask] = React.useState(false);
  const [listData, setListData] = React.useState([]);
  const [SettingsListData, setSettingsListData] = React.useState({});
  const [allContracts, setAllContracts] = React.useState([]);
  const siteURLContext = useMyContext();
  // const [siteURL, setsiteURL] = React.useState(siteURLContext.value || siteURL);
  const [error, setError] = React.useState(null);
  const [currentUserID, setcurrentUserID] = React.useState('');
  const [siteURLVal, setsiteURLVal] = React.useState(siteURL)
  const [userImgUrl,setUserImgUrl]=React.useState("")
  const userKey = useAppSelector(c => c.UserValues.userKey)
  const delay = React.useCallback((ms: number) =>
    new Promise((res) => setTimeout(res, ms))
    , [])

  React.useEffect(()=>{
    
    // getImageURL()
    UserFetchFunction();
    getSettingsListData()
  },[userKey])
  React.useEffect(()=>{
    initializeIcons()
    const siteUrl=localStorage.getItem("SiteURL")
    setsiteURLVal(siteUrl)

    // const userESSPersona: IPersonaSharedProps = {
    //   imageUrl: "/_layouts/15/userphoto.aspx?size=L&accountname=" + currentUser?.["currentUserEmail"],

    // };
    // setImageURL(userESSPersona)
  },[])

  
  const UserFetchFunction = async () => {
    //  // Assuming you're using Redux for state management
  
    try {
      const token = localStorage.getItem("CurrentToken");
      const baseUrl = ContextService.GetUrl();
      const siteUrl=localStorage.getItem("SiteURL")
      const endpoint = `${siteUrl}/_api/web/lists/getbytitle('CLM365Users')/items?$select=ID,UserStatus,LastSeenDate,AssignTo/ID,SPUser/Title,SPUser/ID,email,Manager/Title,Manager/EMail,Manager/ID,GUID,Role,Created&$expand=SPUser,Manager,AssignTo&$top=5000`;
  
      const response = await axios.get(endpoint, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include the token here
        },
      });
  
      const data = response.data;
  
      if (!data?.value?.length) {
        await delay(1500);
        await UserFetchFunction(); // Recursive call to fetch again if no data
        return;
      }
  
      const temp = [];
      data.value?.forEach((curr, indx) => {
        if (curr?.email?.toLowerCase() === currentUser?.currentUserEmail?.toLowerCase()) {
          // dispatch(setRole(curr?.Role));
          // dispatch(setCurrentUser(curr));
          const currentUserObject={
            ...currentUser,
            currentUserId:curr?.SPUser?.ID ,
            currentUserRole: curr?.Role,
            currentUserGuid: currentUser?.GUID,
            displayName: currentUser?.currentUserName,
            email: curr?.email,
            loginName: curr?.email
          }
          setcurrentUserID(curr?.SPUser?.ID )
          localStorage.setItem("CurrentUser", JSON.stringify(currentUserObject));
        }
  
        temp.push({
          text: curr?.SPUser?.Title,
          email: curr?.email,
          GUID: curr?.GUID,
          key: curr?.SPUser?.ID,
          Id: curr?.SPUser?.ID,
          RowId: curr?.ID,
          Role: curr?.Role,
          Manager: {
            ...curr.Manager,
            UserName: curr?.Manager?.UserName || curr?.Manager?.EMail,
          },
          UserStatus: curr?.UserStatus,
          AssignTo: curr?.AssignTo?.ID,
          LastSeenDate: curr?.LastSeenDate,
        });
      });
  
      dispatch(setUsers(temp));
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // const getImageURL=async()=>{
  //   const imageURL=localStorage.getItem('UserImageURL')||"";
  //   if(!isStringValidated(imageURL)){
      
  //       const apiUrl = `https://graph.microsoft.com/v1.0/users/${currentUser?.["currentUserEmail"]}/photo/$value`; // Using email (userPrincipalName) to fetch profile image
  //       const token = localStorage.getItem("CurrentToken");
  //       const responseBlob:any= await axios({
  //         method: 'get',
  //         url: apiUrl,
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           // 'Accept': 'application/json;odata=verbose'
  //         },
  //         responseType: 'blob' // Specify that you expect a blob response
  //       })
  //       console.log(responseBlob)
  //                   const imageBlob = responseBlob?.data; // Directly use the blob data
  //           const imageUrl = URL.createObjectURL(imageBlob); 
  //           setUserImgUrl(imageUrl)
  //           localStorage.setItem(
  //             "UserImageURL",imageUrl
  //           );
  //       // axios.get(apiUrl, {
  //       //   headers: {
  //       //     Authorization: `Bearer ${localStorage?.getItem("CurrentToken")}`, // Include the access token
  //       //   },
  //       //   responseType: 'blob', // Set response type to handle binary data
  //       // })
  //         // .then((response) => {
  //         //   const imageBlob = response.data; // Directly use the blob data
  //         //   const imageUrl = URL.createObjectURL(imageBlob); 
  //         //   setUserImgUrl(imageUrl)
  //         //   localStorage.setItem(
  //         //     "UserImageURL",imageUrl
  //         //   );
  //         // })
  //         // .catch((error) => {
  //         //   console.error("Error fetching user profile image:", error);
  //         // });
      
      
  //   }else{
  //     setUserImgUrl(imageURL)
  //   }
    
  // }  
  const getSettingsListData=async()=>{
    try{
      const token = localStorage.getItem("CurrentToken");

      const siteUrl=localStorage.getItem("SiteURL")
      const endpoint = `${siteUrl}/_api/web/lists/getbytitle('CLM365Settings')/items?$select=*`;
  
      const response = await axios.get(endpoint, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include the token here
        },
      });
      const data = response.data;
      setSettingsListData(data.value[0])
      const azureOpenAIData = data.value[0]?.AzureAI;
      const CopilotData = data.value[0]?.CopilotIntegration;
      localStorage.setItem("AzureAI", azureOpenAIData);
      localStorage.setItem("Copilot",CopilotData);
    }catch(error){
      console.log(error)
    }



  }


  React.useEffect(() => {
    fetchListData( "CLM365Contract_Type");
  }, [isOpenRequest]);


  function handleHome(){
    setisOpenRequest(false);
    setisNewContract(false);
    setCreateRequestAI(false)
    setisReviewContract(false);
    setisGetFilesCLM(false);
    setisAskLegal(false);
    setisUpdateExisting(false);
    setisSettings(false);
    setisHomeOnly(true);
    setAdhocTask(false)
  }
  function handleOpenRequest() {
    setisOpenRequest(true);
    setisNewContract(false);
    setCreateRequestAI(false)
    setisReviewContract(false);
    setisUpdateExisting(false);
    setisGetFilesCLM(false);
    setisAskLegal(false);
    setisSettings(false);
    setisHomeOnly(false);
    setAdhocTask(false)
  }
  function handleNewContract(isAI) {
    setisOpenRequest(false);
    setisNewContract(!isAI);
    setCreateRequestAI(isAI)
    setisReviewContract(false);
    setisGetFilesCLM(false);
    setisUpdateExisting(false);
    setisAskLegal(false);
    setisSettings(false);
    setisHomeOnly(false);
    setAdhocTask(false)
  }
  function handleReviewContract() {
    setisOpenRequest(false);
    setisNewContract(false);
    setisReviewContract(true);
    setisGetFilesCLM(false);
    setisUpdateExisting(false);
    setisAskLegal(false);
    setisHomeOnly(false);
    setisSettings(false);
  }
  function handleUpdateExisting() {
    setisOpenRequest(false);
    setisNewContract(false);
    setCreateRequestAI(false)
    setisReviewContract(false);
    setisUpdateExisting(true);
    setisGetFilesCLM(false);
    setisAskLegal(false);
    setisSettings(false);
    setAdhocTask(false)
    setisHomeOnly(false);
  }
  function handleGetFilesCLM() {
    setisOpenRequest(false);
    setisNewContract(false);
    setCreateRequestAI(false)
    setisReviewContract(false);
    setisUpdateExisting(false);
    setisGetFilesCLM(true);
    setisAskLegal(false);
    setisSettings(false);
    setisHomeOnly(false);
    setAdhocTask(false)
  }
  function handleAdhocTaskCLM(){
    setisOpenRequest(false);
    setisNewContract(false);
     setCreateRequestAI(false)
    setisReviewContract(false);
    setisUpdateExisting(false);
    setisGetFilesCLM(false);
    setisAskLegal(false);
    setisSettings(false);
    setisHomeOnly(false);
    setAdhocTask(true)
  }
  function handleAskLegal() {
    setisOpenRequest(false);
    setisNewContract(false);
    setisReviewContract(false);
    setisUpdateExisting(false);
    setisGetFilesCLM(false);
    setisAskLegal(true);
    setisHomeOnly(false);
    setisSettings(false);
    setAdhocTask(false)
  }
  function handleSettings() {
    setisOpenRequest(false);
    setisNewContract(false);
    setisReviewContract(false);
    setCreateRequestAI(false)
    setisUpdateExisting(false);
    setisGetFilesCLM(false);
    setisAskLegal(false);
    setisSettings(true);
    setisHomeOnly(false);
    setAdhocTask(false)
  }

  const fetchListData = async ( listName) => {
    // console.log(currentUser);
    const token = localStorage.getItem("CurrentToken");
    const siteUrl=localStorage.getItem("SiteURL")
  //  console.log(siteUrl);
    const endpoint = `${siteUrl}/_api/web/lists/getByTitle('${listName}')/items`;
  
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json;odata=verbose",
        },
      });
  
      // console.log(response.data.d.results);
      setAllContracts(response.data.d.results); // Array of list items
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => fetchListData(listName));
    } else{
      console.error("Error fetching list data:", error);
      return null;
    }
   }
  };

  return (
    <>
      <div className="cardMainContainer">
        {!isHomeOnly && <div className="BackButtonContainer flexalignSpcBetween">
          <div className="flexalignCenter headerLogoAndLabel">
            {/* {!isOpenRequest && !isNewContract && !isReviewContract && !isAskLegal && ( */}
              {isOpenRequest || isSettings ? (
                <div title="Home">

                <HomeRegular onClick={() => handleHome()} title="Home" />
                  </div>
         
              ) : isNewContract || isReviewContract || isAskLegal|| CreateRequestAI  ? (
                
                <div  title="Back" ><ArrowCircleLeftRegular onClick={() => handleOpenRequest()} title="Back" /></div>
               
              ) : isUpdateExisting || isGetFilesCLM|| AdhocTask ? (
              
                <div  title="Back" >  <ArrowCircleLeftRegular onClick={() => handleHome()} title="Back" /></div>
               
              ) : null}
            {/* // )} */}
            {/* <div className="flexalignCenter LogoText">
            <img
              // src="https://ik.imagekit.io/zn4au2jftpm5/hr365/Icons/Icons-1200px/CLM365_v77dALssz8.png?updatedAt=1699945885682"
              src="https://ik.imagekit.io/zn4au2jftpm5/hr365/white%20logo/CLM365-White-12001200_Ciou1mRlyB.png?updatedAt=1699247194701"
              alt="CLM365"
            />
            <Label>Contract Management 365</Label>
            </div> */}
          </div>
          <div className="flexalignCenter SendButtons">
          <div className={"SendButtons"}>
            {/* <SettingsRegular onClick={() => handleSettings()} title="Settings"/> */}
            </div>
            {/* <Avatar
              name={currentUser?.["currentUserName"]}
            /> */}
            {/* <Persona 
               styles={{
                root: {
                    display:"block"
                }
            }}
             size={PersonaSize.size32}
             imageUrl={userImgUrl|| "/path/to/default/image.jpg"}
            //  imageUrl={siteURLVal +"/_layouts/15/userphoto.aspx?size=L&accountname=" + currentUser?.["currentUserEmail"]}
            /> */}
          </div>
        </div>}
        <div className={"settingsButton"}  title="Settings">
            <SettingsRegular onClick={() => handleSettings()}/>
          </div>
        {!isOpenRequest && !isNewContract &&!CreateRequestAI && !isReviewContract && !isAskLegal && isHomeOnly && (
          <>
            { CurrentUser.currentUserRole !=='Analyst' && <><div className="CardDivContainer">
              <Card className="ms_card_container" onClick={handleOpenRequest}>
                <div className="card_icon">
                  <AddFilled />
                </div>
                <div className="card_contnet">
                  <Label className="card_heading">Create a new request</Label>
                  <Label className="card_description">
                    Attach necessary documents and email content to start a new request.
                  </Label>
                </div>
              </Card>
            </div><div className="CardDivContainer" onClick={handleUpdateExisting}>
                <Card className="ms_card_container">
                  <div className="card_icon">
                    <LayerRegular />
                  </div>
                  <div className="card_contnet">
                    <Label className="card_heading">Update an existing request</Label>
                    <Label className="card_description">
                      Create a new version, reply to messages, complete tasks, or send for signature.
                    </Label>
                  </div>
                </Card>
              </div></>}
            <div className="CardDivContainer" onClick={handleGetFilesCLM}>
              <Card className="ms_card_container">
                <div className="card_icon">
                  <DocumentAddRegular />
                </div>
                <div className="card_contnet">
                  <Label className="card_heading">Retrieve files from Contract Management </Label>
                  <Label className="card_description">
                  Attach files and documents from Contract Management to your outgoing email.
                  </Label>
                </div>
              </Card>
            </div>
            <div className="CardDivContainer" onClick={handleAdhocTaskCLM} style={{marginBottom: '40px'}}>
              <Card className="ms_card_container">
                <div className="card_icon">
                  <TaskListLtrRegular />
                </div>
                <div className="card_contnet">
                  <Label className="card_heading">Adhoc Task</Label>
                  <Label className="card_description">
                  Add supplementary tasks to an existing request for further processing or follow-up.
                  </Label>
                </div>
              </Card>
            </div>
          </>
        )}

        {isOpenRequest && !isNewContract &&!CreateRequestAI&& !isReviewContract && !isAskLegal && (
          <>
            <div className="CardDivContainer">
              <Card className="ms_card_container" onClick={()=>handleNewContract(false)}>
                <div className="card_icon">
                  <DocumentOnePageAddRegular />
                </div>
                <div className="card_contnet">
                  <Label className="card_heading">Create Request</Label>
                  <Label className="card_description">Request a new contract</Label>
                </div>
              </Card>
            </div>
            
            <div className="CardDivContainer">
              <Card className="ms_card_container" onClick={()=>handleNewContract(true)}>
                <div className="card_icon">
                  <ChatMultipleRegular />
                </div>
                <div className="card_contnet">
                  <Label className="card_heading">AI Request</Label>
                  <Label className="card_description">Create request using AI from outlook mail</Label>
                </div>
              </Card>
            </div>
          </>
        )}

        {isUpdateExisting && (
          <>
            <UpdateExisting isUpdateExisting={isUpdateExisting} setisUpdateExisting={setisUpdateExisting} currentUser={currentUser} handleHome={handleHome} SettingsListData={SettingsListData}/>
          </>
        )}

        {isGetFilesCLM && (
          <>
            <GetFilesCLM isGetFilesCLM={isGetFilesCLM} setisGetFilesCLM={setisGetFilesCLM} SettingsListData={SettingsListData} />
          </>
        )}

        {isNewContract ? (
          <>
            <NewContract
              isNewContract={isNewContract}
              setisNewContract={setisNewContract}
              allContracts={allContracts}
              tokenvalue={tokenvalue}
              siteURL={siteURLVal}
              currentUser={currentUser}
              setisOpenRequest={setisOpenRequest}
              currentUserID={currentUserID}
              SettingsListData={SettingsListData}
              setCreateRequestAI={setCreateRequestAI}
            />
          </>
        ) :CreateRequestAI?(<>
          <RequestAI  CreateRequestAI={CreateRequestAI}
              setCreateRequestAI={setCreateRequestAI}        
               allContracts={allContracts}
              tokenvalue={tokenvalue}
              siteURL={siteURLVal}
              currentUser={currentUser}
              setisOpenRequest={setisOpenRequest}
              currentUserID={currentUserID}
              SettingsListData={SettingsListData} 
              isNewContract={isNewContract}
              setisNewContract={setisNewContract}
              isFromAI={false}/>
        </>)
         : isReviewContract ? (
          <>
            <ReviewContract isReviewContract={isReviewContract} setisReviewContract={setisReviewContract} />
          </>
        ) : isAskLegal ? (
          <>
            <AskLegal isAskLegal={isAskLegal} setisAskLegal={setisAskLegal} />
          </>
        ) : isSettings ? (
          <>
            <Settings isSettings={isSettings} setisSettings={setisSettings} handleHome={handleHome}/>
          </>
        ) : AdhocTask? (<>
        <AdhocTaskPane SettingsListData={SettingsListData}/> 
        </>):null}
      </div>
    </>
  );
};

export default Home;
